import React from "react"

import commonData from "../common/commonData"
import { pagesLinks } from "../common/links"

import Automatization from "../../assets/svg/complexAutomatization__header.svg"
import Wl from "../../assets/svg/wl.svg"
import Qrm from "../../assets/svg/qrm.svg"
import Kds from "../../assets/svg/kds.svg"
import Terminal from "../../assets/svg/logotype.svg"
import Crm from "../../assets/svg/crm__header.svg"
import Menu from "../../assets/svg/menu__header.svg"
import Analytics from "../../assets/svg/analytics__header.svg"
import Warehouse from "../../assets/svg/warehouse__header.svg"
import WlShopMenuIcon from "../../assets/svg/wlShopMenuIcon.svg"

export default {
	menuItems: [
		{
			main: pagesLinks.capability.index,
			additionalLinks: [
				{
					link: {
						useGatsbyLink: pagesLinks.capability.index.useGatsbyLink,
						href: pagesLinks.capability.index.href,
						text: "Комплексная автоматизация",
					},
					icon: <Automatization />,
				},
				{
					link: pagesLinks.terminal,
					icon: <Terminal />,
				},
				{
					link: pagesLinks.indexQRM,
					icon: <Qrm />,
				},
				{
					link: pagesLinks.indexWL,
					icon: <Wl />,
				},
				{
					link: pagesLinks.wlShop.index,
					icon: <WlShopMenuIcon />,
				},
				{
					link: pagesLinks.indexKDS,
					icon: <Kds />,
				},
				{
					link: pagesLinks.bo.systemicApproach,
					icon: <Crm />,
				},
				{
					link: pagesLinks.bo.techMapOrder,
					icon: <Menu />,
				},
				{
					link: pagesLinks.bo.analytics,
					icon: <Analytics />,
				},
				{
					link: pagesLinks.bo.warehouseControl,
					icon: <Warehouse />,
				},
			],
		},
		{
			main: pagesLinks.price.index,
		},
		{
			main: pagesLinks.support,
		},
		{
			main: {
				href: pagesLinks.service.href,
				text: "Обучение",
				useGatsbyLink: true,
			},
			additionalLinks: [
				{
					link: pagesLinks.service,
				},
				{
					link: pagesLinks.restoGuide,
				},
				{
					link: pagesLinks.blog,
				},
			],
		},
		{
			main: pagesLinks.shop.index,
		},
		// {
		//   main: pagesLinks.contacts
		// },
	],
	phone: commonData.phone,
	startButton: pagesLinks.registration,
	license: pagesLinks.lisenceAgreement,
	confidentiality: pagesLinks.privacyPolicy,
	indexPage: pagesLinks.index,
}
